import React, { useContext } from 'react';
import { NotificationContext, NotificationType } from '../../contexts/NotificationContext';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import './Notification.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationCircle, faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons';

const typeIcons: Record<NotificationType, IconDefinition> = {
  success: faCheckCircle,
  error: faExclamationCircle,
  info: faInfoCircle,
  warning: faExclamationCircle, // Can use a different icon for warning if desired
};

const Notification: React.FC = () => {
  const context = useContext(NotificationContext);

  if (!context) {
    // This should not happen if Notification is rendered within NotificationProvider
    return null;
  }

  const { notification, hideNotification } = context;

  if (!notification) {
    return null;
  }

  return (
    <div className={`notification notification-${notification.type} ${notification ? 'show' : ''}`}>
      <FontAwesomeIcon icon={typeIcons[notification.type]} className="notification-icon" />
      <span className="notification-message">{notification.message}</span>
      <button onClick={hideNotification} className="notification-close-button">
        <FontAwesomeIcon icon={faTimes} />
      </button>
    </div>
  );
};

export default Notification;